import { DatePipe } from '@angular/common';
import { Component } from '@angular/core';
import { MatDivider } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { Season } from 'src/app/shared/team.model';
import { TeamService } from 'src/app/shared/team.service';

@Component({
  selector: 'app-season-table-view',
  imports: [MatTableModule, MatPaginatorModule, MatDivider, MatIconModule, DatePipe],
  templateUrl: './season-table-view.component.html',
  styleUrl: './season-table-view.component.css'
})
export class SeasonTableViewComponent {

  displayedColumns: string[] = ['SeasonId','IsCurrent',  'Name', 'StartDate', 'EndDate'];
  dataSource = new MatTableDataSource<Season>();
  currentSeasonAvailable: boolean = false;

  constructor(private teamService: TeamService) {}

  ngOnInit(): void {
    this.loadSeasons();
  }

  loadSeasons(): void {
    this.teamService.getSeasons().subscribe(seasons => {
      console.log(seasons);
      const sortedSeasons = (seasons as Season[]).sort((a, b) => b.SeasonId - a.SeasonId);
      this.currentSeasonAvailable =  this.checkCurrentSeasonAvailable(sortedSeasons);
      this.dataSource.data = sortedSeasons;
    });
  }

  checkCurrentSeasonAvailable(seasons: Season[]): boolean {
    return seasons.some(season => season.IsCurrentSeason === true);
  }


}
